import LogicGates from './LogicGates'

export default LogicGates
